import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, User } from './services/auth.service';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AppConfigService } from './services/app-config.service';
import { AppInfoService } from './services/app-info.service';
import { AppInfo } from './models/app-info';

import { MenuItem } from './models/menu-item';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  watcher: Subscription;
  activeMediaQuery = '';
  appComponentMenuIsOpen: boolean = true;
  internetConnection: boolean;

  currentUser: User;
  drawerMode: string = 'side';
  private drawerModeSource = new BehaviorSubject<string>('');
  drawerMode$ = this.drawerModeSource.asObservable();
  versionnumber: string = '1.0.0.0';

  appInfo: AppInfo = {
    username: null,
    versionNumber: null,
    menuItems: [],
    isBeheerder: null
  };

  constructor(
    private router: Router,
    private appConfigSvc: AppConfigService,
    private authService: AuthService,
    private media: MediaObserver,
    private iconRegistry: MatIconRegistry,
    private appInfoSvc: AppInfoService,
    private sanitizer: DomSanitizer
  ) {
    this.watcher = this.media.asObservable().subscribe((change) => {
      change.forEach((item) => {
        this.activeMediaQuery = item ? item.mqAlias : '';
        if (item.mqAlias == 'xs' || item.mqAlias == 'sm') {
          this.appComponentMenuIsOpen = false;
          this.drawerMode = 'over';
          this.drawerModeSource.next(this.drawerMode);
        } else {
          this.appComponentMenuIsOpen = true;
          this.drawerMode = 'side';
          this.drawerModeSource.next(this.drawerMode);
        }
      });
    });
    this.versionnumber = this.appConfigSvc.getConfig().version;
    this.setupIconRegistry();
  }

  ngOnInit() {
    this.authService.getUser().subscribe((u) => {
      this.currentUser = u;
      this.appInfoSvc.get().subscribe((a) => {
        this.appInfo = a;
      });
    });
  }

  ngOnDestroy() {
    this.watcher.unsubscribe();
  }

  login() {
    this.authService.login();
  }

  public DrawerMode(): string {
    return this.drawerMode;
  }

  public SetDrawerMode(mode: string) {
    this.drawerMode = mode;
    this.drawerModeSource.next(this.drawerMode);
  }

  public navigate(pad: string) {
    if (pad && pad.startsWith('http')) {
      window.location.href = pad;
    }

    if (
      this.activeMediaQuery == 'xs' ||
      this.activeMediaQuery == 'sm' ||
      this.drawerMode == 'over'
    ) {
      this.appComponentMenuIsOpen = false;
    }

    this.router.navigateByUrl(pad);
  }

  public naam(): string {
    if (
      !!this.currentUser &&
      !!this.currentUser.profile &&
      !!this.currentUser.profile['name']
    ) {
      return this.currentUser.profile['name'];
    } else {
      return 'Onbekend';
    }
  }

  public menuIsOpen(): boolean {
    return this.appComponentMenuIsOpen;
  }

  public toggleMenu() {
    this.appComponentMenuIsOpen = !this.appComponentMenuIsOpen;
  }

  public toggleChildren(item: MenuItem) {
    item.childrenVisible = !item.childrenVisible;
  }

  setupIconRegistry() {
    this.iconRegistry.addSvgIcon(
      'lan_connect',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/lan-connect.svg'
      )
    );
    this.iconRegistry.addSvgIcon(
      'lan_disconnect',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/lan-disconnect.svg'
      )
    );
    this.iconRegistry.addSvgIcon(
      'lan_pending',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/lan-pending.svg'
      )
    );
    this.iconRegistry.addSvgIcon(
      'cloud_off',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/cloud-off-24px.svg'
      )
    );
    this.iconRegistry.addSvgIcon(
      'cloud',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/cloud-24px.svg'
      )
    );
    this.iconRegistry.addSvgIcon(
      'settings',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/settings.svg')
    );

    this.iconRegistry.addSvgIcon(
      'DisciplineA',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/DisciplineA.svg'
      )
    );
    this.iconRegistry.addSvgIcon(
      'DisciplineB',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/DisciplineB.svg'
      )
    );
    this.iconRegistry.addSvgIcon(
      'DisciplineP',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/DisciplineP.svg'
      )
    );
  }
}
